export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="bg-gradient-to-br from-background-950 to-background-900 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
                <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-900/30 rounded-full mb-4 whitespace-nowrap">
                  多端观影
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                  随时随地，想看就看
                </h2>
                <p className="text-sm md:text-base text-background-300 leading-relaxed mb-6 max-w-md">
                  成全影院适配手机、平板、电脑全终端，无论你身处何地，打开浏览器就能畅享高清免费电影在线观看体验。无需下载，即点即播，高清不卡顿。
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                  {[
                    { icon: 'ri-smartphone-line', label: '手机端' },
                    { icon: 'ri-tablet-line', label: '平板端' },
                    { icon: 'ri-computer-line', label: '电脑端' },
                  ].map((d) => (
                    <div key={d.label} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 text-white/80 text-sm whitespace-nowrap">
                      <i className={`${d.icon} text-accent-400`}></i>
                      {d.label}
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex-1 w-full lg:max-w-[420px] p-6 md:p-8 lg:p-0 lg:pr-12 flex justify-center">
                <div className="relative w-[240px] h-[480px] rounded-2xl overflow-hidden border-4 border-background-700">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20mockup%20displaying%20cinematic%20movie%20streaming%20interface%20with%20dark%20theme%2C%20warm%20amber%20and%20golden%20accent%20UI%20elements%2C%20film%20poster%20thumbnails%20in%20grid%20layout%2C%20sophisticated%20dark%20background%2C%20modern%20minimal%20app%20design%2C%20rich%20contrast%2C%20premium%20streaming%20platform%20look&width=480&height=960&seq=app-mobile-mock&orientation=portrait"
                    alt="成全影院移动端观影界面"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}